import { useState, useEffect, useContext } from 'react';
import { ColorProvider, ColorContext } from '../Context/ColorContext.js';
import InventoryArtworks from '../Components/Inventory/InventoryArtworks.js';
import { useParams } from 'react-router-dom';


function InventoryPage() {
  
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="">
      <ColorProvider>
        <Content menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      </ColorProvider>
    </div>
  );
}

function Content({ menuOpen, setMenuOpen }) {

  const { category } = useParams();

  let ContentComponent = null;
  switch (category) {
    case 'Artwork':
      ContentComponent = <InventoryArtworks />;
      break;
    case 'Palettes':
      ContentComponent = <div className="text-white p-4">Palettes (Coming Soon)</div>;
      break;
    case 'Pages':
      ContentComponent = <div className="text-white p-4">Pages (Coming Soon)</div>;
      break;
    default:
      ContentComponent = (
        <div className="text-white p-4">
          Invalid category: <strong>{category}</strong>
        </div>
      );
  }

  return (
    <div className="h-screen w-screen bg-slate-900">
      <div className="pt-16 flex w-full">
        <div className="absolute top-[64px] left-0 right-0 bottom-0 flex flex-col overflow-x-hidden">
          {ContentComponent}
        </div>
      </div>
    </div>
  );
}

export default InventoryPage;
